module.exports = {"520115100":"金华镇","520115101":"朱昌镇","520115102":"百花湖镇","520115400":"世纪城社区服务中心","520115401":"金源社区服务中心","520115402":"逸景社区服务中心","520115403":"碧海社区服务中心","520115404":"金麦社区服务中心","520115405":"新世界社区服务中心","520115406":"金华园社区服务中心","520115407":"金岭社区服务中心","520115408":"会展社区服务中心","520115409":"观山社区服务中心"}


//////////////////
// WEBPACK FOOTER
// ./src/town/520115.json
// module id = 2452
// module chunks = 0